import React from 'react';

// PE-435: both participant modals used to render a six-column table to show ONE participant,
// which wrapped Batch Code over five lines and still clipped the email. Same facts, one block.
// Shared because ParticipantConfirmation and ParticipantCheckIn show identical identity data.

const initialsOf = (name) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

export default function ParticipantIdentity({ participant, labels = {} }) {
  if (!participant) return null;

  const meta = [
    participant.employment_id_number && `${labels.id_prefix || 'ID'} ${participant.employment_id_number}`,
    participant.profile_nik && `${labels.nik_prefix || 'NIK'} ${participant.profile_nik}`,
    participant.profile_email
  ].filter(Boolean);

  const chips = [participant.order_name, participant.service_package_name].filter(Boolean);

  return (
    <div className="participant-identity">
      <div className="participant-identity__avatar" aria-hidden="true">
        {initialsOf(participant.profile_full_name)}
      </div>

      <div className="participant-identity__detail">
        <div className="participant-identity__name">{participant.profile_full_name}</div>

        {meta.length > 0 &&
          <div className="participant-identity__meta">
            {meta.map((item, index) => (
              <React.Fragment key={item}>
                {index > 0 && <span className="participant-identity__separator" aria-hidden="true">·</span>}
                <span>{item}</span>
              </React.Fragment>
            ))}
          </div>
        }

        {chips.length > 0 &&
          <div className="participant-identity__chips">
            {chips.map(chip => (
              <span className="participant-identity__chip" key={chip}>{chip}</span>
            ))}
          </div>
        }
      </div>
    </div>
  );
}

export { initialsOf };
